import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66cd3bdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "c-radio-label"
}
const _hoisted_2 = ["id", "value", "checked"]
const _hoisted_3 = ["for", "data-value"]

type RadioOption = {
  label?: string
  value?: string | number
}
type RadioOptions = RadioOption[]
interface Props {
  options: RadioOptions;
  label?: string;
  value?: string | number;
  layout?: string;
}

const __default__ = {
  name: 'CRadioGroup'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    options: null,
    label: null,
    value: null,
    layout: { default: "row" }
  },
  emits: ["update:value"],
  setup(__props: any, { emit }) {

const props = __props as { options: RadioOptions, label?: string, value?: string | number, layout: string };




const onChange = (e: Event) => {
  const target = (e.target as HTMLInputElement)
  if (target.tagName === "LABEL") {
    emit("update:value", target.dataset.value)
  } else if (target.tagName === "INPUT") {
    emit("update:value", target.value)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['c-radio-group', props.layout])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.label) + ":", 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "c-radio",
        key: item.value,
        onClick: onChange
      }, [
        _createElementVNode("input", {
          type: "radio",
          id: `radio_${index}`,
          value: item.value,
          checked: props.value === item.value
        }, null, 8, _hoisted_2),
        _createElementVNode("label", {
          for: `radio_${index}`,
          "data-value": item.value
        }, _toDisplayString(item.label), 9, _hoisted_3)
      ]))
    }), 128))
  ], 2))
}
}

})